import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockTestimonials } from '../mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our{' '}
            <span className="bg-gradient-to-r from-[#2CC84B] to-[#00BCD4] bg-clip-text text-transparent">
              Customers
            </span>{' '}
            Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join hundreds of satisfied customers who are saving money and going green
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockTestimonials.map((testimonial) => (
            <Card
              key={testimonial.id}
              className="hover:shadow-[0_0_25px_rgba(44,200,75,0.15)] transition-all duration-300 hover:-translate-y-2 border-t-4 border-t-[#2CC84B] border-l-4 border-l-[#2CC84B]"
            >
              <CardContent className="pt-6">
                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 mb-6 italic leading-relaxed">
                  "{testimonial.text}"
                </p>

                {/* Customer Info */}
                <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full"
                  />
                  <div>
                    <p className="font-bold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.location}</p>
                    <span className={`inline-block mt-1 text-xs px-2 py-1 rounded-full ${
                      testimonial.type === 'Residential'
                        ? 'bg-[#2CC84B]/10 text-[#2CC84B]'
                        : 'bg-[#00BCD4]/10 text-[#00BCD4]'
                    }`}>
                      {testimonial.type}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <p className="text-4xl md:text-5xl font-bold text-[#2CC84B] mb-2">4.9/5</p>
            <p className="text-gray-600">Customer Rating</p>
          </div>
          <div>
            <p className="text-4xl md:text-5xl font-bold text-[#00BCD4] mb-2">500+</p>
            <p className="text-gray-600">Projects Completed</p>
          </div>
          <div>
            <p className="text-4xl md:text-5xl font-bold text-[#2CC84B] mb-2">98%</p>
            <p className="text-gray-600">Customer Satisfaction</p>
          </div>
          <div>
            <p className="text-4xl md:text-5xl font-bold text-[#3F51B5] mb-2">24/7</p>
            <p className="text-gray-600">Support Available</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
